import React from 'react';
import { EMPTY_STATE_MESSAGE } from '../../constants/messages';

interface EmptyStateProps {
  message?: string;
  icon?: string | React.ReactNode;
  showRetry?: boolean;
  onRetry?: () => void;
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({ 
  message = EMPTY_STATE_MESSAGE,
  icon = '📊',
  showRetry = false,
  onRetry,
  className = ''
}) => {
  return (
    <div className={`flex flex-col items-center justify-center h-full text-text-secondary p-4 ${className}`} role="alert" aria-live="polite">
      <div className="text-4xl mb-4">
        {typeof icon === 'string' ? icon : icon}
      </div>
      <div className="text-lg font-medium">{message}</div>
      {showRetry && onRetry && (
        <button 
          onClick={onRetry}
          className="mt-4 px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors"
        >
          تلاش مجدد
        </button>
      )}
    </div>
  );
};

export default EmptyState;